const api = '/api/v1/u008_p_tran_info_controller.php';
import axios from 'axios';
export const tran_info_repository =  {
    get(data){
        return  axios.get(`${api}?PARENT_ID=${data}`);
    },
    upd(data){
        return  axios.post(api, data);
    },
    patch(data){
        return  axios.patch(api, data);
    }
};

